// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const NV_MODULO_FISCAL = {
  Essential: 'NV_MODULO_FISCAL1',
  Advanced: 'NV_MODULO_FISCAL2',
  Compliance: 'NV_MODULO_FISCAL3',
  Nenhum: 'NENHUM',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    NV_MODULO_FISCAL1: 1,
    NV_MODULO_FISCAL2: 2,
    NV_MODULO_FISCAL3: 3,
    NENHUM: 9999
  }
}
